import { ITextStyle } from './interaces';

const CELLS = 20;
const ROWS = 30;

const GRID = Array.from(Array(ROWS), (_, rowIndex) =>
  new Array(CELLS).fill(0).map((_, cellIndex) => `${rowIndex}-${cellIndex}`)
);

const SENSOR_CONFIG = { activationConstraint: { distance: 10 } };

const DEFAULT_TEXT_STYLE: ITextStyle = {
  fontSize: 12,
  color: '#707072',
  horizontalAlign: 'flex-start',
  verticalAlign: 'flex-start',
};

export { GRID, SENSOR_CONFIG, DEFAULT_TEXT_STYLE };
